<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
    }
  }
}
</script>

<style>
  body{
    margin:0;
    padding:0;
  }
  .full-screen-container {
    height: 100vh;
    width: 100%;
  }
</style>
